import React from "react";
import "../styles/Intro.scss";

export function Intro() {
  return (
    <section className="intro">
      <div>
        <p>Hello, my name is</p>
        <h1>Chris Adams.</h1>
        <h2>I'm a Full Stack Web Developer</h2>
        <a href="mailto:cladams0203@gmail.com">Contact me</a>
      </div>
    </section>
  );
}
